import { createSlice } from '@reduxjs/toolkit'

const initialValue = {

    max_change_request:3,
    request_changes: false,
    open_request_changes_popup: false,
    open_video_accept_popup: false,
    open_video_reject_popup: false,
    final_video_id: '',
    final_video_url: "",
    download_link: "",
    final_video_accepted: false,
    revision_logs: [],
    timestamp:'00:00',
    open_change_request_tutorial_popup: false,
    is_loading: false,
   // new_video: false,
   // under_revision: false,
   ///////////////////pharoah starts///////////////////
   editing_cycles_list:[],
   internal_revisions_list:[],
   internal_revision_details:{},
   selected_video_logs_list:[],
   is_loading:false,
   delete_log_confirmation_popup:false,
   editing_cycle_id: null,
   internal_revision_id:null,
   log_id:null, 
   edit_flag:false,
   log:null,
   selected_video_url:null,
   selected_video_ids:[],
   selected_video_id_one:null,
   selected_video_id_two:null,
   revision_details_loading: false,
   compare_user_input_video_popup:false,
   user_revision:null,
   can_upload: false,
   display_video_playback_page: false,
   view_brandbox_page:false,
   show_video_checklist: true,
   accept_internal_revision_loading:false,
   sent_for_approval_loading:false
}


export const reviewSlice = createSlice({
    name: 'review',
    initialState: initialValue,
    reducers: {
        updateReviewState: (state, action) => {
            assignValueInState(action.payload, state)
        },
        resetReviewState: (state) => {
            assignValueInState(initialValue, state)
        },
    },
})

const assignValueInState = (obj, state) => {
    for (const key in obj) { state[key] = obj[key] }
}

export const { updateReviewState, resetReviewState } = reviewSlice.actions
export default reviewSlice.reducer